import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { authApi } from "@/api/auth.ts";
import { Alert, Button, Field, Input, PageTitle } from "@/ui/primitives.tsx";
import { useApiError } from "@/ui/useApiError.ts";
import { AuthLayout } from "./AuthLayout.tsx";
import { useSetAuthUser } from "./session.ts";

export function SetupPage() {
  const { t } = useTranslation();
  const toMsg = useApiError();
  const nav = useNavigate();
  const setUser = useSetAuthUser();
  const [form, setForm] = useState({ email: "", name: "", password: "" });
  const m = useMutation({
    mutationFn: () => authApi.setup(form),
    onSuccess: ({ user }) => {
      setUser(user);
      void nav({ to: "/" });
    },
  });
  return (
    <AuthLayout>
      <form
        className="space-y-5"
        onSubmit={(e) => {
          e.preventDefault();
          m.mutate();
        }}
      >
        <PageTitle title={t("setup.title")} subtitle={t("setup.subtitle")} />
        {m.error && <Alert tone="danger">{toMsg(m.error)}</Alert>}
        <Field label={t("common.name")}>
          <Input required autoFocus value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
        </Field>
        <Field label={t("common.email")}>
          <Input type="email" dir="ltr" required autoComplete="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
        </Field>
        <Field label={t("common.password")} hint={t("common.passwordHint")}>
          <Input type="password" dir="ltr" required minLength={12} autoComplete="new-password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
        </Field>
        <Button type="submit" className="w-full" loading={m.isPending}>{t("setup.submit")}</Button>
      </form>
    </AuthLayout>
  );
}
